import {Dispatch} from "redux";
import {QuicktipActionTypes, QuicktipAction} from "../../../types/composer/Quicktip/quicktipTypes";
import axios from "axios";

export const getQuicktipData = (id:string): any => {
    return async (dispatch: Dispatch<QuicktipAction>) => {
        try {
            dispatch({type: QuicktipActionTypes.FETCH_QUICKTIP_DATA});
            const response = await axios({
                method: 'get',
                url: `/api/composer/quicktips/${id}`,
                withCredentials: false
            });
            dispatch({type: QuicktipActionTypes.FETCH_QUICKTIP_DATA_SUCCESS, payload: response.data})
        } catch (error) {
            dispatch({type: QuicktipActionTypes.FETCH_QUICKTIP_DATA_ERROR, payload: 'Something wend wrong check Quicktip action controller'});
        }
    }
}